import { createSlice } from "@reduxjs/toolkit";

import { IPoInput } from "../../modules/raw-material/models/rmm_models";
import { getInitialState } from "../../modules/raw-material/utils/poUtils";


interface IPurchaserState {
    inputForm:IPoInput
}

const initialState: IPurchaserState = {
    inputForm:getInitialState()
};

const purchaserSlice = createSlice({
  name: "purchaser",
  initialState,
  reducers: {
    initiatePOInputState(state, action){
      state.inputForm=getInitialState(action.payload)
    },
    setPOInputState(state, action){
       state.inputForm=action.payload
    },
    updatePOInputState(state:any, action) {
      const key = Object.keys(action.payload)[0];
      if (!key) return;
      const value=action.payload[key]
      state.inputForm[key] = value;
     
    },
    appendPOItem(state, action) {
      state.inputForm.items.push(action.payload);
    },
  }
});

export const { initiatePOInputState, updatePOInputState, setPOInputState, appendPOItem } =
  purchaserSlice.actions;

export default purchaserSlice.reducer;
